import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "session-main-wrapper" }
const _hoisted_2 = { class: "mx-auto session-modal col-2 p-3" }
const _hoisted_3 = { class: "text-center" }
const _hoisted_4 = { class: "mx-auto" }
const _hoisted_5 = { key: 0 }
const _hoisted_6 = { key: 1 }
const _hoisted_7 = { class: "session-button-wrapper text-center" }
const _hoisted_8 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _cache[2] || (_cache[2] = _createElementVNode("div", { class: "session-cloak" }, null, -1)),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('session_end_text')), 1),
          _createElementVNode("p", null, _toDisplayString(_ctx.$t('time_left')), 1),
          _createElementVNode("div", _hoisted_4, [
            (this.time.minutes <= 0 && this.time.seconds <= 0)
              ? (_openBlock(), _createElementBlock("h3", _hoisted_5, _toDisplayString('00:00')))
              : (_openBlock(), _createElementBlock("h3", _hoisted_6, _toDisplayString('0' + this.time.minutes + ':' + (this.time.seconds < 10 ? ('0' + this.time.seconds) : this.time.seconds)), 1))
          ])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("button", {
            class: "p-2 px-5 bg-primary text-center session-button text-white border-0",
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.refresh())),
            disabled: this.time.minutes <= 0 && this.time.seconds <= 0
          }, _toDisplayString(_ctx.$t('continue')), 9, _hoisted_8),
          _createElementVNode("button", {
            class: "p-2 px-5 bg-secondary session-button text-white border-0",
            onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.quit()))
          }, _toDisplayString(_ctx.$t('quit')), 1)
        ])
      ])
    ])
  ], 64))
}